module.exports = __webpack_public_path__ + "media/site_templates/www.localgardeners.com.au/images/review_1-dcf0218d7d9c8967a5ce07217ea41417.png";